import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import ReactLoading from "react-loading";

class   CategoryForm extends Component{

    state = {
        id : "",
        name : "",
        icone : "",
        description : "",
        parentId : null,
        error : "",

        titlepage : "",
        categories : [],
        btn : false
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    storeCategory = async (e) => {
        this.setState({
            btn : !this.state.btn
        })

        let data = {
            name : this.state.name,
            description : this.state.description,
            icone : this.state.icone,
            parentId : this.state.parentId
        }
        
        var request = this.state.id ? axios.put('categories/' + this.state.id, data )  : axios.post('categories', data) ;
        
        request.then((response) =>{
            this.setState({
                error : "saved success",
                btn : !this.state.btn
            });
            this.props.showModal();
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg,
                btn : !this.state.btn
            })
        })
        
    }

    async categories () {
        var categories = await axios.get("categories");
        if(categories.status == 200){
            this.setState({
                categories : categories.data
            })
        }
    }
    
    edit=()=>  {
        this.form()
        this.categories()
    }

    form=()=>{
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            name: this.props.formData ? this.props.formData.name : "",
            icone: this.props.formData ? this.props.formData.icone : "",
            description: this.props.formData ? this.props.formData.description : "",
            parentId: this.props.formData ? this.props.formData.parentId : null,
            titlepage : this.props.formData ? "Modifier la categorie" : "Ajouter la categorie",
            error : "",
        })
    }

    render(){

        return(
            <div>
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title>{ this.state.titlepage}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form   className="row">
                        <div className="text-center text-danger text-small small">{ this.state.error }</div>
                        <div className="col-md-6 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Groupe</label>
                                <div className="position-relative mt-1">
                                    <select id="type" name="parentId"   value={this.state.parentId} onChange={this.handleInput} className="form-select">
                                        <option value="">...</option>
                                        {
                                            this.state.categories.filter(data => !data.parentId).map((category) => {
                                                return(
                                                    <option key={category.id} value={category.id}>{category.name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Catégorie</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="name"  value={this.state.name} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Description</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="description"  value={this.state.description} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Icone</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="icone"  value={this.state.icone} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6 mt-2 mt-2">
                        
                            <div className=" pt-2 text-center">
                                <span className="text-danger"> { this.state.error }</span><br />
                                <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm me-3" type="button"><i className="bi bi-corner-down-left"></i> Fermer</button>
                                <button className="btn btn-sm btn-primary py-1 rounded rounded-3" disabled={ this.state.btn } onClick={ () => this.storeCategory() } >Sauvegarder{ !this.state.btn ? <i className="bi bi-check"></i> : <ReactLoading type="spokes" color="red" className="float-end" height={15} width={15} />}</button>
                            </div>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>


        </div>
        )
    }
}
export default CategoryForm;
